<!-- Base App Template -->
<template>
  <div>
    <NavBar />
    <router-view />
    <Footer socials />
  </div>
</template>

<script>
// import components
import NavBar from "@/components/global-styles/components/NavBar.vue";
import Footer from "@/components/global-styles/components/Footer.vue";

export default {
  name: "App",
  components: {
    NavBar,
    Footer,
  },
};
</script>

<style>
.other-paragraph {
  font-size: 1em;
  color: black;
  margin: 0;
  line-height: 1.6;
  font-family: PT Serif, serif;
}
.buttonBox {
  display: flex;
  justify-content: center;
}
@media (max-width: 768px) {
  .buttonBox {
    flex-direction: column;
    align-items: center;
    gap: 1em;
  }
}
</style>
